import firebase from 'firebase/app'
import 'firebase/functions'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: "AIzaSyAK3XdHt84dMXifwtWvEBjxYyZBGk2PjeQ",
  authDomain: "bookuploader-dbed9.firebaseapp.com",
  databaseURL: "https://bookuploader-dbed9.firebaseio.com",
  projectId: "bookuploader-dbed9",
  storageBucket: "bookuploader-dbed9.appspot.com",
  messagingSenderId: "116533600617",
  appId: "1:116533600617:web:791d006142b7cfa0a6ddf8"
};
firebase.initializeApp(firebaseConfig);

// export function gAuth() {
//   let provider = new firebase.auth.GoogleAuthProvider();
//   provider.addScope('profile');
//   provider.addScope('email');
//   return provider
// }

export const auth = firebase.auth()
export const func = firebase.functions()
export const storage = firebase.storage()
export const db = firebase.firestore()

// export default firebase